import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { IProps } from './types';

const ScrollToTop: React.FC<IProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <>{children}</>;
};

export default ScrollToTop;
